import { useEffect, useState } from "react";
import { subscribeStudioMarkers, type StudioMarker } from "@/lib/firestore/studioMarkers";

export function useStudioMarkers(projectId: string | null) {
  const [markers, setMarkers] = useState<StudioMarker[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setMarkers([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    return subscribeStudioMarkers(
      projectId,
      (data) => {
        setMarkers(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [projectId]);

  return { markers, loading, error };
}
